/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import utils from '../../../common/utils';

const CDN_TOKEN_COOKIE = 'etext-cdn-token';

const readCdnTokenFromCookie = () => {
  const cookies = document.cookie;
  if (!cookies) {
    return { name: '', value: '' };
  }
  const match = cookies.split('; ').find((entry) => entry.startsWith(`${CDN_TOKEN_COOKIE}=`));
  if (!match) {
    return { name: '', value: '' };
  }
  const value = match.slice(CDN_TOKEN_COOKIE.length + 1);
  return value ? { name: CDN_TOKEN_COOKIE, value } : { name: '', value: '' };
};

class AuthConfig {
  constructor({ useRplusEpubAuth = false } = {}) {
    this.useRplusEpubAuth = useRplusEpubAuth;
  }

  getAuthConfig = () => {
    return {
      getTokenConfig: this.getTokenConfig,
      getCdnToken: this.getCdnToken,
      getToken: this.getToken,
      getHawkConfig: this.getHawkConfig,
      getUserId: this.getUserId,
      onError: this.onError
    };
  };

  /**
   * Get hawk config
   */
  getHawkConfig = () => {
    const hawkConfig = {
      hawkId: '',
      hawkKey: ''
    };

    return hawkConfig;
  };

  /**
   * Get token
   */
  getToken = () => {
    const secret = this.useRplusEpubAuth ? utils.getToken() : '';
    const tokenConfig = {
      id: '',
      token: secret || '',
      userRole: '',
      type: ''
    };

    return Promise.resolve(tokenConfig);
  };

  /**
   * Get token config
   */
  getTokenConfig = () => {
    const tokenConfig = {
      callApigee: false,
      id: '',
      type: '',
      userRole: ''
    };

    return tokenConfig;
  };

  /**
   * Get CDN token
   */
  getCdnToken = () => (this.useRplusEpubAuth ? readCdnTokenFromCookie() : { name: '', value: '' });

  /**
   * Get userid
   */
  getUserId = () => '';

  /**
   * Get gab userid
   */
  getGabUserId = () => '';

  /**
   * On error
   */
  onError = () => {
    const error = {};

    return error;
  };
}

export default AuthConfig;
